import React, { useEffect, useState } from 'react';
import TooltipComponent from '../common/Tooltip/Tooltip';
import { useTranslation } from 'react-i18next';
import Loader from '../common/Loader/Loader';
import API from '../../utils/ApiConfig';
import { TIME_DIMENSION_ONBOARDING } from '../../utils/ApiEndpoints';
import AutomatedOnboardingFooter from '../AutomatedOnboardingFooter/AutomatedOnboardingFooter';

const AutomatedOnboardingTime = props => {
  const { commonProps, activeStep, onActiveStepChange, onInitializationError, onDataSaveError, onNavigationError, onDataSaveNotification } = props;

  const [pageInitialized, setPageInitialized] = useState(false); //...flag indicates if the page was loaded properly (no error)
  const [isLoading, setLoading] = useState(false);

  const [fiscalCalendarTypes, setFiscalCalendarTypes] = useState([]);
  const [fiscalCalendarTypeSelected, setFiscalCalendarTypeSelected] = useState('Calendar Months');
  const [monthsFiscalYear, setMonthsFiscalYear] = useState([]);
  const [monthFiscalYearSelected, setMonthFiscalYearSelected] = useState('January');
  const [fiscalNameBasedOnData, setFiscalNameBasedOnData] = useState([]);
  const [fiscalNameBasedOn, setFiscalNameBasedOn] = useState('Year End');
  const [profileId, setProfileId] = useState('');

  const { t } = useTranslation();
  const tc = (e, data) => (data ? t(`dimension:${e}`, data) : t(`dimension:${e}`));
  const tct = (e, data) => (data ? t(`autoonboard_time:${e}`, data) : t(`autoonboard_time:${e}`));

  useEffect(() => {
    setFiscalCalendarTypes(getFiscalCalendarTypes());
    setMonthsFiscalYear(getMonthsFiscalYear());
    setFiscalNameBasedOnData(getFiscalNameBasedOnData());

    setLoading(true);
    API.get(TIME_DIMENSION_ONBOARDING, {})
      .then(response => {
        setFiscalCalendarTypeSelected(response.data.fiscalCalendarType);
        setMonthFiscalYearSelected(response.data.firstMonthInFiscalYear);
        setFiscalNameBasedOn(response.data.fiscalYearBasedOn);
        setProfileId(response.data.profileId);
        setPageInitialized(true);
      })
      .catch(err => {
        onInitializationError(err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const getFiscalCalendarTypes = () => {
    return [{ id: 0, name: 'Calendar Months' }];
  };

  const getMonthsFiscalYear = () => {
    return _.map(moment.months(), function (element, key) {
      return { id: key, name: element };
    });
  };

  const getFiscalNameBasedOnData = () => {
    return [
      { id: 0, name: 'Year End' },
      { id: 1, name: 'Year Begin' },
    ];
  };

  const handleMonthChange = event => setMonthFiscalYearSelected(event.target.value);

  // footer
  const save = (saveType, callbackfn) => {
    if (!pageInitialized) {
      onDataSaveError(null); //...unexpected error, call of this method should not be possible
      return;
    }

    setLoading(true);
    API.put(TIME_DIMENSION_ONBOARDING, {
      saveType: saveType,
      timeDimensionDTO: {
        profileId: profileId,
        firstMonthInFiscalYear: monthFiscalYearSelected,
      },
    })
      .then(() => {
        callbackfn();
      })
      .catch(err => {
        onDataSaveError(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const footerBtnInfo = {
    nextBtn: { disabled: false, showBtn: true, click: save },
    saveBtn: { disabled: false, showBtn: true, click: save },
    saveExitBtn: { disabled: false, showBtn: true, click: save },
  };

  return (
    <div className={'automated-onboarding-time'}>
      {isLoading ? <Loader /> : ''}

      <div className={'automated-onboarding-time-content'}>
        <div className="automated-onboarding-title title">{tct('AUTOMATED_ONBOARDING_TIME_TITLE')}</div>
        <div className="automated-onboarding-subtitle">{tct('AUTOMATED_ONBOARDING_TIME_SUBTITLE')}</div>

        <div className={'automated-onboarding-time-section'}>
          <div>
            <label className="control-label">{tc('DIMENSION_TIME_FISCAL_CALENDAR_TYPE')}</label>
          </div>
          <div>
            <input type="text" value={fiscalCalendarTypeSelected} className="form-control" disabled="disabled" />
          </div>
        </div>

        <div className={'automated-onboarding-time-section'}>
          <div>
            <label className="control-label">{tc('DIMENSION_TIME_FIRST_MONTH_FISCAL_YEAR')}</label>
            <TooltipComponent title={tc('DIMENSION_TIME_TOOLTIP_FIRST_MONTH_FISCAL_YEAR')}>
              <span className="badge warning-color mouse-pointer">?</span>
            </TooltipComponent>
          </div>
          <div>
            <select className="form-control" value={monthFiscalYearSelected} onChange={handleMonthChange} autoFocus>
              {monthsFiscalYear.length &&
                monthsFiscalYear.map(item => (
                  <option value={item.name} key={item.id}>
                    {item.name}
                  </option>
                ))}
            </select>
          </div>
        </div>

        <div className={'automated-onboarding-time-section'}>
          <div>
            <label className="control-label">{tc('DIMENSION_TIME_FIRST_FISCAL_NAME_BASED_ON')}</label>
          </div>
          <div>
            <input type="text" value={fiscalNameBasedOn} className="form-control" disabled="disabled" />
          </div>
        </div>
      </div>

      <AutomatedOnboardingFooter
        commonProps={commonProps}
        btnInfo={footerBtnInfo}
        activeStep={activeStep}
        pageInitialized={pageInitialized}
        onActiveStepChange={s => onActiveStepChange(s)}
        onNavigationError={e => onNavigationError(e)}
        onDataSaveNotification={e => onDataSaveNotification(e)}
      />
    </div>
  );
};

export default AutomatedOnboardingTime;